import { useState, useCallback } from 'react';

export interface CertificationModalState {
  isOpen: boolean;
  mode: 'add' | 'edit';
  editData: any;
  editCertificationId: string | null;
  isLoadingDetails: boolean;
}

export const useCertificationModal = () => {
  const [modalState, setModalState] = useState<CertificationModalState>({
    isOpen: false,
    mode: 'add',
    editData: null,
    editCertificationId: null,
    isLoadingDetails: false,
  });

  const openAddModal = useCallback(() => {
    setModalState({
      isOpen: true,
      mode: 'add',
      editData: null,
      editCertificationId: null,
      isLoadingDetails: false,
    });
  }, []);

  const openEditModal = useCallback((certificationId: string, certificationData?: any) => {
    setModalState({
      isOpen: true,
      mode: 'edit',
      editData: certificationData,
      editCertificationId: certificationId,
      isLoadingDetails: !certificationData, // Loading if no data provided initially
    });
  }, []);

  const closeModal = useCallback(() => {
    setModalState(prev => ({
      ...prev,
      isOpen: false,
      isLoadingDetails: false,
    }));
  }, []);

  const setEditData = useCallback((data: any) => {
    setModalState(prev => ({
      ...prev,
      editData: data,
      isLoadingDetails: false,
    }));
  }, []);

  const setLoading = useCallback((loading: boolean) => {
    setModalState(prev => ({
      ...prev,
      isLoadingDetails: loading,
    }));
  }, []);

  return {
    modalState,
    openAddModal,
    openEditModal,
    closeModal,
    setEditData,
    setLoading,
  };
};
